var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.info),function(item,index){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.imgUrl),expression:"item.imgUrl"}],key:index})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }